import * as Sentry from "@sentry/react";
import upperFirst from "lodash/upperFirst";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { getPartnerByHost } from "./appSettings/Partners";

const env = import.meta.env.VITE_ENVIRONMENT

if (env !== "development") {
  // Edit env name to match BE
  const envBe = env === 'production' ? 'prod' : env
  const environment = upperFirst(envBe + (getPartnerByHost().deployment ?? ''))

  Sentry.init({
    dsn: "https://cef007fe617ab1fbd71484faebddfd48@sentry.docker01.cebia.cz/13",
    tunnel: (import.meta.env.VITE_BASE_URL ?? '') + "/tunnel",
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        beforeAddRecordingEvent: (event) => {
          // Do not capture fetch/xhr requests details, unless the response status code > 400
          if (
            event.data.tag === "performanceSpan" &&
            (event.data.payload.op === "resource.fetch" || event.data.payload.op === "resource.xhr") &&
            event.data.payload.data.statusCode < 400
          ) {
            if (event.data.payload.data.response)
              event.data.payload.data.response.body = null;

            if (event.data.payload.data.request)
              event.data.payload.data.request.body = null;
          }

          return event;
        },
        networkDetailAllowUrls: [window.location.origin],
        maskAllText: false,
        maskAllInputs: false,
      })
    ],

    // Change tracesSampleRate to 10 % for test and prep environments and 1 % for all other environments
    tracesSampleRate: env === "test" || env === "prep" ? 0.1 : 0.01,

    // Přidává sentry hlavičky pro dané requesty
    tracePropagationTargets: [
      // /^\//
    ],

    // Change replaysSessionSampleRate to 10 % for test and prep environments and 1 % for all other environments
    replaysSessionSampleRate: env === "test" || env === "prep" ? 0.1 : 0.01,
    replaysOnErrorSampleRate: 1.0,

    // Vypne reporty, ktere nepodporuje self-hosted Sentry
    sendClientReports: false,

    environment
  })

  console.debug('Sentry is initialized.', env)
}
else {
  console.debug("Sentry is disabled in development mode")
}